import { Table, Form, Input, Tooltip, Space, Button } from "antd";
import { useEffect, useState, useRef } from "react";
import {
  GetAllClientCreds,
  GetClientLoginUrl,
  UpdateClientCredential,
} from "../../Repository/ClientCredentialsRepository";
import {
  EditOutlined,
  SearchOutlined,
  CopyOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { useTenantStyle } from "../../Utils/Utils";
import { InfoMessage, SuccessMessage } from "../../Utils/Utils";

const EditableCell = ({
  dataIndex,
  children,
  editing,
  onSave,
  onCancel,
  ...restProps
}) => {
  const inputRef = useRef();

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const handleSave = async () => {
    try {
      await onSave();
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `Please enter ${dataIndex}!`,
            },
          ]}
        >
          <Input
            ref={inputRef}
            onPressEnter={handleSave}
            // onBlur={handleSave}
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const GridCredentialUpdate = () => {
  const [loading, setLoading] = useState(true);
  const [EditingRecord, setEditingRecord] = useState(null);
  const IsRecordInEditingState = (Id) => Id === EditingRecord;
  const [clientsData, setClientsData] = useState([]);
  const [form] = Form.useForm();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [SearchGrid, setSearchGrid] = useState("");
  // Fetch All clients data on component mount
  useTenantStyle();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const clientsData = await GetAllClientCreds();
        if (clientsData) {
          const sortedData = clientsData.sort((a, b) =>
            a.VMS.localeCompare(b.VMS)
          );
          setClientsData(sortedData);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    console.log(selectedKeys)
    console.log(dataIndex)
    confirm();
    setSearchText(
      selectedKeys && selectedKeys.length > 0 ? selectedKeys[0] : ""
    ); 
    setSearchedColumn(dataIndex);
  };
  const handleReset = async (clearFilters) => {
    clearFilters();
    setSearchText("");
    try {
      let Data = await GetAllClientCreds();
      setClientsData(Data);
    } catch (error) {
      console.error("Error resetting filters:", error);
    }
  };

  const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 80 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters);
         
            }}
            size="small"
            style={{ width: 80 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filteredValue: [searchText],
    onFilter: (value, record) => {
      const clientName = record && record.Client_Name;
      const VmsName= record && record.VMS;
     
      return (
        clientName && String(clientName).toLowerCase().includes(value.toLowerCase()) || 
        VmsName && String(VmsName).toLowerCase().includes(value.toLowerCase())

      )
      // return clientName && String(clientName).toLowerCase().includes(value.toLowerCase());
    
    
  },

  
  });
   //Filter Feature for Grid Layout
 const filterProps = () => ({
  filteredValue: [SearchGrid],
  onFilter: (value, record) => {
    return (
      String(record.Client_Name)
        .toLowerCase()
        .includes(String(value).toLowerCase()) ||
      String(record.VMS)
        .toLowerCase()
        .includes(String(value).toLowerCase()) 
      
    );
  },
});

const SearchEmployee = (value) => {
  // console.log(value);
  setSearchGrid(value);
};
const handleCopy = (text) => {
  navigator.clipboard.writeText(text);
  SuccessMessage("Copied to clipboard!");
};

  // Columns configuration for the user table
  const UserTableColumns = [
    {
      title: "Vms Name",
      dataIndex: "VMS",
      sorter: (a, b) => a.VMS.localeCompare(b.VMS),
      onFilter: (value, record) => record.VMS.indexOf(value) === 0,
      width: "9%",
      // ...getColumnSearchProps("VMS", "Search Client Name"),
      ...filterProps(),
    
    },
    {
      title: "Client Name",
      dataIndex: "Client_Name",
      width: "17%",
      sorter: (a, b) => a.Client_Name.localeCompare(b.Client_Name),
      sortDirections: ["descend", "ascend"],
      // ...getColumnSearchProps("Client_Name", "Search Client Name"),
      ...filterProps(),
    },

    // {
    //   title: "User Name",
    //   dataIndex: "portal_username",
    //   editable: true,
    //   width: "16%",
    // },
    {
      title: "User Name",
      dataIndex: "portal_username",
      editable: true,
      width: "16%",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>{text}</span>
          <Tooltip title="Copy Username">
            <Button
              type="link"
              icon={<CopyOutlined />}
              onClick={() => handleCopy(text)}
              style={{ marginLeft: 8 }}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Password",
      dataIndex: "portal_password",
      editable: true,
      width: "9%",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {IsRecordInEditingState(record.Id) ? (
            <EditableCell
              dataIndex={`portal_password_${record.Id}`}
              editing={IsRecordInEditingState(record.Id)}
            />
          ) : (
            <>
              <span>********</span>
              <Tooltip title="Copy Password">
                <Button
                  type="link"
                  icon={<CopyOutlined />}
                  onClick={() => handleCopy(record.portal_password)}
                  style={{ marginLeft: 8 }}
                />
              </Tooltip>
            </>
          )}
        </div>
      ),
    },
    {
      title: "Portal",
      width: "17%",
      dataIndex: "url",
      render: (_, record) => {
        return (
          <a
            onClick={() => handleSourceLinkClick(record)}
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {record.Client_Name}
          </a>
        );
      },
    },
  ];

  const MergedColumns = UserTableColumns.map((column) => {
    if (column.editable) {
      return {
        ...column,
        onCell: (record) => ({
          record,
          dataIndex: column.dataIndex,
          title: column.title,
          editing: IsRecordInEditingState(record.Id),
          onSave: () => SaveUser(record),
          form,
        }),
      };
    }
    return column;
  });

  const handleSourceLinkClick = async (record) => {
    const Response = await GetClientLoginUrl(record);
    if (Response != null) {
      window.open(Response, "_blank");
      // window.open(Response, '_blank', 'width=800,height=600')
    }
  };
  const onRowDoubleClick = (record) => {
    if (!IsRecordInEditingState(record.Id)) {
      EditUser(record);
    } else {
      CancelEditing();
    }
  };

  const EditUser = (record) => {
    form.setFieldsValue({ ...record });
    setEditingRecord(record.Id);
  };

  const CancelEditing = () => {
    setEditingRecord(null);
  };
  const SaveUser = async () => {
    try {
      if (!form.isFieldsTouched()) {
        InfoMessage("No changes to Save");
        return;
      }

      const formData = form.getFieldValue();
      const Response = await UpdateClientCredential(formData);

      if (Response != null) {
        setEditingRecord(null);
        SuccessMessage(Response.message);
        setClientsData(await GetAllClientCreds());
      }
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };


  // Map and transform data for the table
  const data =
    clientsData && clientsData.length > 0
      ? clientsData.map((client) => ({
          Id: client.Id,
          VMS: client.VMS,
          Payroll: client.Payroll,
          Client_Name: client.Client_Name,
          portal_username: client.portal_username,
          portal_password: client.portal_password,
        }))
      : [];

  return (
    <Form form={form} component={false}>
      <div className="input-searchs">
      <Input
            placeholder="Search with VMS/Client Name"
            className="input-search"
            style={{ borderColor: "#002766", color: "#F4F9FF" }}
            onChange={(e) => SearchEmployee(e.target.value)}
            suffix={
              <SearchOutlined
                className="search-icon"
              />
            }
          />
          <div className="note-text"> Note:  Double click on the Rows to make them Editable and Press Enter to Save the changes , Double Click to Disable editing</div>

      </div>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        columns={MergedColumns}
        loading={loading}
        dataSource={data}
        scroll={{ y: 430 }}
        bordered
        pagination={false}
        className="grid-table"
        onRow={(record, rowIndex) => ({
          onDoubleClick: () => onRowDoubleClick(record),
        })}
      />
    </Form>
  );
};

export default GridCredentialUpdate;
